export class DashboardCancelResponse {
    Error: boolean;
    Message: string;
  }
  